const initLogoLoop = async () => {
    const holder = document.querySelectorAll<HTMLElement>('.wp-block-gallery.is-style-loop');
    if (!holder.length) return;

    const { default: Swiper } = await import("swiper");
    const { Autoplay } = await import("swiper/modules");

    const initHolderAsLoop = (holder: HTMLElement) => {
        if (holder.clientWidth < (document.documentElement.clientWidth * .92) || holder.classList.contains('swiper-wrapper')) return;

        holder.childNodes.forEach(child => holder.appendChild(child.cloneNode(true) as HTMLElement))

        const wrapper = document.createElement('div')
        wrapper.classList.add('swiper')

        holder.insertAdjacentElement('beforebegin', wrapper)
        wrapper.appendChild(holder)

        holder.classList.add('swiper-wrapper', '!ease-linear')
        holder.classList.remove('wp-block-gallery', 'is-layout-flex')

        new Swiper(wrapper, {
            modules: [Autoplay],
            slidesPerView: 'auto',
            slideClass: 'wp-block-image',
            spaceBetween: 80,
            loop: true,
            speed: 4000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
            },
            allowTouchMove: false,
            freeMode: false,
            breakpoints: {
                768: {
                    spaceBetween: 128,
                },
            }
        })
    }

    holder.forEach(holder => initHolderAsLoop(holder))
    window.addEventListener("resize", () => holder.forEach(holder => initHolderAsLoop(holder)), { passive: true })
    window.addEventListener("scroll", () => holder.forEach(holder => initHolderAsLoop(holder)), { passive: true })
}

export default initLogoLoop